import { render } from "@/components/organisms/bmdModal/BMDModal.html?vue&type=template&id=284b0565&external"
import script from "@/components/organisms/bmdModal/BMDModal.js?vue&type=script&lang=js&external"
export * from "@/components/organisms/bmdModal/BMDModal.js?vue&type=script&lang=js&external"

import "@/components/organisms/bmdModal/BMDModal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__